export enum UploadType {
  Product,
  Restaurant
}
